import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'dateFormat'})
export default class DateFormatPipe implements PipeTransform {
  transform(timestamp: number): string {
    const
      date = new Date(timestamp),
      day = date.getDate(),
      month = date.getMonth() + 1,
      year = date.getFullYear();

    let
      fullDay = day < 10 ? '0' + day : day,
      fullMonth = month < 10 ? '0' + month : month;

    return `${fullDay}.${fullMonth}.${year}`;
  }
}
